var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "subjects_page_wrapper" } },
    [
      _c("div", { staticClass: "bb-mobile-header" }, [
        _c("div", { staticClass: "bb-mobile-header-left" }, [
          _c(
            "button",
            {
              staticClass: "mobile-sidebar-btn",
              on: {
                click: function ($event) {
                  return _vm.openMobileAside()
                },
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "feather feather-menu",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                },
                [
                  _c("line", {
                    attrs: { x1: "3", y1: "12", x2: "21", y2: "12" },
                  }),
                  _c("line", {
                    attrs: { x1: "3", y1: "6", x2: "21", y2: "6" },
                  }),
                  _c("line", {
                    attrs: { x1: "3", y1: "18", x2: "21", y2: "18" },
                  }),
                ]
              ),
            ]
          ),
        ]),
        _c("h1", [_vm._v(_vm._s(_vm.$t("subjects.title")))]),
        _c("div", { staticClass: "bb-mobile-header-right" }),
      ]),
      _c("div", { staticClass: "d-flex justify-content-between" }, [
        _c(
          "div",
          { staticClass: "bb-subjects-table-search d-flex align-items-center" },
          [
            _c("i", { staticClass: "flaticon-search" }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchTerm,
                  expression: "searchTerm",
                },
              ],
              attrs: {
                type: "text",
                placeholder: _vm.$t("subjects.searchInput.placeholder"),
              },
              domProps: { value: _vm.searchTerm },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.searchTerm = $event.target.value
                },
              },
            }),
          ]
        ),
        _c(
          "button",
          {
            staticClass: "bb-new-subject-btn",
            on: { click: _vm.createSubject },
          },
          [_vm._v(" " + _vm._s(_vm.$t("subjects.createSubjectBtn")) + " ")]
        ),
      ]),
      _c("v-data-table", {
        ref: "subjectsTable",
        staticClass: "bb-table subjects-table",
        attrs: {
          headers: _vm.tableHeaders,
          items: _vm.allSubjects,
          search: _vm.searchTerm,
          "hide-default-footer": "",
          page: _vm.pagination.page,
          "items-per-page": _vm.pagination.itemsPerPage,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.pagination, "page", $event)
          },
          "page-count": function ($event) {
            _vm.pagination.pageCount = $event
          },
          pagination: function ($event) {
            return _vm.updatePaginationText($event)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function ({ item }) {
              return [
                _c("tr", [
                  _c(
                    "td",
                    {
                      staticClass: "text-left",
                      on: {
                        click: function ($event) {
                          return _vm.showSubject(item.id)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "bb-subject-badge" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              item.type == "Culpability"
                                ? _vm.$t(
                                    "subjectFormModal.type.options.culpability"
                                  )
                                : _vm.$t(
                                    "subjectFormModal.type.options.litigation"
                                  )
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "td",
                    {
                      staticClass: "text-left",
                      on: {
                        click: function ($event) {
                          return _vm.showSubject(item.id)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(item.subjectNumber) + " ")]
                  ),
                  _c(
                    "td",
                    {
                      staticClass: "text-left",
                      on: {
                        click: function ($event) {
                          return _vm.showSubject(item.id)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(item.courtNumber) + " ")]
                  ),
                  _c(
                    "td",
                    {
                      staticClass: "text-left",
                      on: {
                        click: function ($event) {
                          return _vm.showSubject(item.id)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(item.courtName) + " ")]
                  ),
                  _c(
                    "td",
                    {
                      staticClass: "text-left",
                      on: {
                        click: function ($event) {
                          return _vm.showSubject(item.id)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            item.client
                              ? item.client.first_name +
                                  " " +
                                  item.client.last_name
                              : "Unknown"
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "td",
                    { staticClass: "text-right" },
                    [
                      _c("BBDropdown", {
                        attrs: { positionClass: "right" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "toggle",
                              fn: function () {
                                return [
                                  _c("i", { staticClass: "ki ki-more-ver" }),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "items",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "action-item" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: {
                                              name: "subject",
                                              params: { id: item.id },
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "far fa-user",
                                          }),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "subjects.subjectDropdown.showBtn"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "action-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.editSubject(item)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "flaticon2-gear",
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "subjects.subjectDropdown.editBtn"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "action-item danger",
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteSubject(item)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "far fa-trash-alt",
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "subjects.subjectDropdown.deleteBtn"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
      _c(
        "div",
        { staticClass: "bb-table-footer subjects-table-footer" },
        [
          _c("v-pagination", {
            staticClass: "bb-pagination",
            attrs: { length: _vm.pagination.pageCount },
            model: {
              value: _vm.pagination.page,
              callback: function ($$v) {
                _vm.$set(_vm.pagination, "page", $$v)
              },
              expression: "pagination.page",
            },
          }),
          _c(
            "div",
            {
              staticClass: "d-flex justufy-content-between align-items-center",
            },
            [
              _c("BBSelect", {
                staticClass: "bb-pagination-per-page-select",
                attrs: { options: _vm.pagination.perPageOptions },
                model: {
                  value: _vm.pagination.itemsPerPage,
                  callback: function ($$v) {
                    _vm.$set(_vm.pagination, "itemsPerPage", $$v)
                  },
                  expression: "pagination.itemsPerPage",
                },
              }),
              _c("span", { staticClass: "bb-table-pagination-text" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("subjects.table.pagination.show")) +
                    " " +
                    _vm._s(_vm.pagination.currentFromItem) +
                    " - " +
                    _vm._s(_vm.pagination.currentToItem) +
                    " " +
                    _vm._s(_vm.$t("subjects.table.pagination.of")) +
                    " " +
                    _vm._s(_vm.pagination.currentTotalItems) +
                    " "
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { attrs: { id: "mobile_subjects_wrapper" } }, [
        _c("div", { staticClass: "bb-input-group search-input" }, [
          _c("i", { staticClass: "fas fa-search" }),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchTerm,
                expression: "searchTerm",
              },
            ],
            attrs: {
              type: "text",
              placeholder: _vm.$t("subjects.mobileSearchInput.placeholder"),
            },
            domProps: { value: _vm.searchTerm },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.searchTerm = $event.target.value
              },
            },
          }),
          _c(
            "button",
            {
              staticClass: "bb-badge badge-rounded",
              on: {
                click: function ($event) {
                  _vm.searchTerm = ""
                },
              },
            },
            [_c("i", { staticClass: "ki ki-close icon-md" })]
          ),
        ]),
        _c(
          "div",
          { staticClass: "subjects-list" },
          _vm._l(_vm.displaySubjects, function (subject) {
            return _c(
              "div",
              {
                key: subject.id,
                staticClass: "subject-item",
                on: {
                  click: function ($event) {
                    return _vm.showSubject(subject.id)
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-start align-items-center",
                  },
                  [
                    _c("div", { staticClass: "bb-subject-badge" }, [
                      _vm._v(" " + _vm._s(subject.initials) + " "),
                    ]),
                    _c("div", { staticClass: "subject-details" }, [
                      _c("span", [_vm._v(_vm._s(subject.subjectNumber))]),
                      _c("small", [_vm._v(_vm._s(subject.courtNumber))]),
                      _c("small", [_vm._v(_vm._s(subject.courtName))]),
                    ]),
                  ]
                ),
                _c("i", { staticClass: "la la-angle-right" }),
              ]
            )
          }),
          0
        ),
        _c(
          "button",
          {
            staticClass: "mobile-new-subject-btn",
            on: { click: _vm.createSubject },
          },
          [_c("i", { staticClass: "la la-plus" })]
        ),
      ]),
      _c("SubjectFormModal", { ref: "subjectFormModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }